<template>
  <span class="interval-indicator" :style="{ background: color }"></span>
</template>

<script>
import { computed } from 'vue'
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  },

  setup(props) {
    return {
    };
  }
}
</script>

<style lang="scss" scoped>
.interval-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
</style>